/* ==========================================================
   REBELLE — comportements globaux
   Apparition au défilement des éléments .rv (ajout de .in).
   Le CSS gère déjà les cas .no-js et prefers-reduced-motion ;
   ici on ne fait qu'observer et révéler.
   ========================================================== */
(function () {
  function revealAll(nodes) {
    nodes.forEach(function (el) { el.classList.add('in'); });
  }

  function setup(root) {
    var scope = root || document;
    var reveals = scope.querySelectorAll('.rv:not(.in)');
    if (!reveals.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      revealAll(Array.prototype.slice.call(reveals));
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.15 });

    reveals.forEach(function (el) { io.observe(el); });
  }

  setup();

  /* L'éditeur de thème recharge des sections à la volée : re-scanner. */
  document.addEventListener('shopify:section:load', function (event) {
    setup(event.target);
  });

  /* ---- Formulaire de réservation du camion (snippet formulaire-camion) ----
     Présent sur l'accueil et la page food-truck ; no-op ailleurs. */
  document.querySelectorAll('form.booking').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var hp = form.querySelector('.hp input');
      if (hp && hp.value.trim() !== '') e.preventDefault(); // leurre rempli = robot
    });
  });

  /* Après un envoi réussi, amener la confirmation à l'écran. */
  (function () {
    var ok = document.querySelector('[data-booking-success]');
    if (!ok) return;
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    ok.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'center' });
    ok.focus();
  })();
})();
